<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import Vue from 'vue';

  export default {
    props: {
      date: {
        type: String,
        default: '',
      },
      format: {
        type: String,
        default: 'jYYYY/jMM/jDD-HH:mm:ss',
      },
    },
    computed: {
      jalaliDate: function () {
        if (this.date) return Vue.moment(this.date).format(this.format);
        else return '-';
      },
    },
  };
</script>
<template>
  <div>
    {{ jalaliDate }}
  </div>
</template>
